import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.accessibleResources.has(_ctx.resource.type))
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToResource(_ctx.resource)), ["stop"])),
        class: "cursor-pointer text-primary"
      }, _toDisplayString(_ctx.resource.text || _ctx.resource.id || _ctx.resource.alias), 1))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.resource.text || _ctx.resource.id || _ctx.resource.alias), 1))
}